import PropTypes from "prop-types";
import { Box } from "@mui/material";
import "flag-icons/css/flag-icons.min.css";

/** Flag of an ISO country code; nothing for a code without one. */
export function CountryFlag({ code, width = 20 }) {
  const iso = String(code || "").toLowerCase();
  if (!/^[a-z]{2}$/.test(iso)) return null;
  return (
    <Box
      component="span"
      aria-hidden
      className={`fi fi-${iso}`}
      sx={{
        width: `${width}px !important`,
        height: Math.round(width * 0.75),
        lineHeight: 1,
        flexShrink: 0,
        backgroundSize: "cover",
        borderRadius: "3px",
        boxShadow: "0 0 0 1px rgba(15, 23, 42, 0.08)",
      }}
    />
  );
}

CountryFlag.propTypes = { code: PropTypes.string, width: PropTypes.number };
